module.exports = __webpack_public_path__ + "static/media/sport-chariots.0c95acb1.mp4";